import { useEffect } from 'react';
import { useGetVehiclesQuery } from '@perxis-auto/instock-sdk/lib/entities/vehicle/api';
import {
  actions as comparisonActions,
  selectors as comparisonSelectors,
} from '@perxis-auto/instock-sdk/lib/features/comparison/model';
import { useAppDispatch, useAppSelector } from '@perxis-auto/instock-sdk/lib/shared/lib/store';

const POLLING_INTERVAL = 60_000 * 5;

export const useComparisonActualize = () => {
  const dispatch = useAppDispatch();

  const comparisonIds = useAppSelector(state => comparisonSelectors.selectIds(state.comparison));
  const parameters = useAppSelector(comparisonSelectors.selectComparableVehiclesParameters);

  const queryResult = useGetVehiclesQuery(parameters, {
    pollingInterval: POLLING_INTERVAL,
    refetchOnFocus: true,
    skip: !comparisonIds.length,
  });

  useEffect(() => {
    if (!queryResult.data) {
      return;
    }

    const currentIds = queryResult.data.items.map(item => item.id);

    dispatch(comparisonActions.actualizeItems(currentIds));
  }, [dispatch, queryResult.data]);

  return queryResult;
};
